import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]

  toggle() {
    const showPassword = this.inputTarget.type === "password"
    this.inputTarget.type = showPassword ? "text" : "password"
    this.buttonTarget.textContent = showPassword ? "Verbergen" : "Anzeigen"
    this.buttonTarget.setAttribute("aria-label", showPassword ? "Passwort verbergen" : "Passwort anzeigen")
    this.buttonTarget.setAttribute("aria-pressed", String(showPassword))
  }
}
